<template>
  <div>
    <div class="page-header border-bottom">
      <h3 class="page-title">Users</h3>
    </div>
    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th>Email</th>
          <th>Fullname</th>
          <th>Added Date</th>
          <th class="is-xs">Role</th>
          <th class="is-xs is-right">Option</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>anousone.luangkhot@gmail.com</td>
          <td>Anousone Luangkhot</td>
          <td>15/05/2021</td>
          <td>Admin</td>
          <td class="is-right">
            <div class="icons">
              <div class="icon bubble"><i class="fas fa-pen"></i></div>
              <div class="icon alert bubble"><i class="fas fa-trash"></i></div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>